import { render, staticRenderFns } from "./TopBarItem.vue?vue&type=template&id=0bf3055e&scoped=true&"
import script from "./TopBarItem.vue?vue&type=script&lang=js&"
export * from "./TopBarItem.vue?vue&type=script&lang=js&"
import style0 from "./TopBarItem.vue?vue&type=style&index=0&id=0bf3055e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bf3055e",
  null
  
)

export default component.exports